<div *ngIf="!edit" class="row invoice-record">
    <div class="col-3">{{ caseName?.beskrivelse }}</div>
    <div class="col-5" style="white-space: pre-wrap;">{{ fakturaLinje.tekst }}</div>
    <div class="col-1 text-end">{{ fakturaLinje.moms }} %</div>
    <div class="col-2 text-end">{{ fakturaLinje['beløb'] | currency:'DKK':'':'1.2-2':'da' }}</div>
    <div *ngIf="editAllowed" class="col-1 text-end invoice-record--hover">
        <i (click)="onDelete()" class="me-1 fa fa-trash text-danger clickable--link"></i>
        <i (click)="onEditChange(true)" class="me-1 fa fa-edit text-primary clickable--link"></i>
    </div>
</div>

<div *ngIf="edit" class="row" [formGroup]="form">
    <div *ngIf="fakturaLinje.flid === 0" class="col-3">
        <select class="form-select form-select-sm" formControlName="sag">
            <option selected disabled [value]="null">{{ caseName?.beskrivelse || '-- Vælg sag --' }}</option>
            <option *ngFor="let sag of createCases" [value]="sag.pid">{{ sag.beskrivelse }} ({{ sag.ufaktureret | currency:'DKK':'':'1.2-2':'da' }})</option>
            <option [value]="0">Aconto</option>
        </select>
    </div>
    <div *ngIf="fakturaLinje.flid > 0" class="col-3">{{ caseName?.beskrivelse }}</div>
    <div class="col-5">
        <app-stdtextarea
            formControlName="tekst"
            side="/timesag/faktura/faktura.asp"
            [field]="'Tekst'">
        </app-stdtextarea>
    </div>
    <div class="col-1 text-end d-flex">
        <input
            type="text"
            formControlName="moms"
            class="text-end form-control form-control-sm">&nbsp;%
    </div>
    <div class="col-2">
      <input
        type="text"
        formControlName="beløb"
        class="text-end form-control form-control-sm">
    </div>
    <div class="col-1 text-end">
        <i (click)="cancelEdit(fakturaLinje.flid)" class="me-1 fa fa-ban text-danger clickable--link"></i>
        <i (click)="onSave()" class="me-1 fa fa-floppy-o text-primary clickable--link"></i>
    </div>
</div>
